const values = {
    "PURCHASE_PRICE": "Precio de Compra",
    "PURCHASE_PRICES": "Precios de Compra",
    "PROFIT": "Ganancia",
}

export default values;